import { authHelper } from './authHelper';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export const pushNotifications = {
  isSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  },

  async getRegistration() {
    return navigator.serviceWorker.register('/push-sw.js', { scope: '/' });
  },

  async isSubscribed() {
    if (!this.isSupported()) return false;
    try {
      const reg = await navigator.serviceWorker.getRegistration('/');
      if (!reg) return false;
      const sub = await reg.pushManager.getSubscription();
      return !!sub;
    } catch (e) {
      return false;
    }
  },

  async subscribe() {
    if (!this.isSupported()) throw new Error('unsupported');

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') throw new Error('permission-denied');

    const keyRes = await fetch(`${API_URL}/api/push/vapid-public-key`);
    const { publicKey } = await keyRes.json();

    const reg = await this.getRegistration();
    await navigator.serviceWorker.ready;

    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
      });
    }

    const res = await fetch(`${API_URL}/api/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHelper.getAuthHeaders() },
      body: JSON.stringify(sub.toJSON())
    });
    if (!res.ok) throw new Error('backend-error');
    return true;
  },

  async unsubscribe() {
    const reg = await navigator.serviceWorker.getRegistration('/');
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return false;
    const payload = sub.toJSON();
    await sub.unsubscribe();
    await fetch(`${API_URL}/api/push/unsubscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHelper.getAuthHeaders() },
      body: JSON.stringify(payload)
    });
    return true;
  },

  async sendTest() {
    const res = await fetch(`${API_URL}/api/push/test`, {
      method: 'POST',
      headers: authHelper.getAuthHeaders()
    });
    return res.ok;
  },

  async notifyExtraction(amount, language) {
    try {
      await fetch(`${API_URL}/api/push/notify-extraction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHelper.getAuthHeaders() },
        body: JSON.stringify({ amount, language })
      });
    } catch (e) {
      console.debug('Push extraction notify failed (in-app banner already shown):', e);
    }
  }
};
